/* Redux-Toolkit */
import {
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";

/* Constants */
import { GlobalMessageType } from "src/shared/constants/common/GlobalMessage";

/* Interfaces */
import { ToastMessageProps } from "src/shared/interfaces/common/ToastMessage";

export const initialState: ToastMessageProps = {
  type: GlobalMessageType.DEFAULT,
  message: undefined,
  show: false,
  url: undefined,
};

export const toastMessageSlice = createSlice({
  name: "toastMessage",
  initialState: initialState,
  reducers: {
    setToastMessage: (
      state,
      action: PayloadAction<ToastMessageProps>
    ) => {
      Object.assign(state, action.payload);
    },
  },
});

/* Actions */
export const { setToastMessage } =
  toastMessageSlice.actions;

/* Reducer */
export default toastMessageSlice.reducer;
